import React, { Component } from 'react'

import {PLATE_REGISTERED_SUCCESS} from '../../../constants'

import {filterParkings, parseTimestamp} from '../../../utils'

class VehiclePlateRegistration extends Component {

    constructor(props){
        super(props)
        this.getErrorMessagesStr = this.getErrorMessagesStr.bind(this)
        this.searchForReservation = this.searchForReservation.bind(this)
    }

    getErrorMessagesStr(errorMessages){
        if (errorMessages.invalidPlate){
            return 'El numero de placa es invalido'
        }
        if (errorMessages.notAvailableSpace){
            return 'No hay espacio disponible en este parqueo'
        }
        if (errorMessages.plateAlreadyRegister){
            return 'La placa ya se encuentra registrada en el parqueo'
        }
        return ''
    }

    searchForReservation(plate, reservedParkings){
        const nowTimestamp = new Date().getTime()
        const foundParkings = filterParkings(
            reservedParkings, nowTimestamp - 60*60*1000, nowTimestamp + 2*60*60*60
        )
        const parkingsWithPlate = foundParkings.filter(el => el.plate === plate.toLowerCase())
        return parkingsWithPlate.length > 0 ? parkingsWithPlate[0] : null
    }

    render(){
        const {
            plate,
            onPlateChange,
            onEnterClick,
            state,
            reservedParkings,
            errorMessages
        } = this.props
        const {getErrorMessagesStr, searchForReservation} = this
        const eventDataErrorsStr = getErrorMessagesStr(errorMessages)
        var reservationFound = ""
        var foundRes = null
        if (!errorMessages.invalidPlate && plate.length > 0){
            foundRes = searchForReservation(plate, reservedParkings)
            if (foundRes != null){
                const startTime = parseTimestamp(foundRes.expected_start)
                const endTime = parseTimestamp(foundRes.end)
                reservationFound = `Reservacion: Entrada: ${startTime.time}, Salida: ${endTime.time}`
            }
            else{
                reservationFound = "Placa no tiene reservacion"
            }
        }
        return(
            <div>
                <div className="line-header-text">Registrar entrada vehiculo</div>
                <div className="events-finder-search">
                    <table>
                            <tr>
                                <th className="table-left">Placa</th>
                                <th>
                                <div className={errorMessages.invalidPlate ? "input-error-container" : "input-block"}>
                                    <input
                                        type="text"
                                        className="text-input"
                                        value={plate}
                                        onChange={onPlateChange}
                                        disabled={errorMessages.notAvailableSpace}
                                    />
                                </div>
                                </th>
                            </tr>
                    </table>
                    </div>
                    <div className="search-button-padding">
                        <input
                            className="button-add-reserve"
                            type="button"
                            value="Ingresar"
                            onClick={onEnterClick}
                            disabled={errorMessages.invalidPlate}/>
                    </div>
                    <div>
                        {
                            state === PLATE_REGISTERED_SUCCESS ?
                            <div className="text-success">Placa registrada exitosamente</div> :
                            <div className="error-message">{eventDataErrorsStr}</div>
                        }
                        {
                            <div className={foundRes ? "info-subtitle": "warning-subtitle"}>
                                {reservationFound}
                            </div>
                        }
                    </div>
            </div>
        )
    }
}

export default VehiclePlateRegistration
